var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDirectionSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49511 16.7453C7.60455 16.8 7.73588 16.8 7.85626 16.7453C8.77557 16.2966 11.5116 14.732 13.7442 10.0598C14.2148 9.075 14.8714 5.82526 12.8468 3.25392C11.041 0.967071 8.3378 0.737305 7.68116 0.737305C6.98074 0.737305 4.32133 0.978013 2.51555 3.25392C0.4909 5.81432 1.14754 9.075 1.61814 10.0598C3.85073 14.732 6.57581 16.3076 7.50605 16.7453H7.49511ZM7.68116 3.36335C9.44316 3.36335 10.8659 4.7858 10.8659 6.54744C10.8659 8.30908 9.44316 9.73153 7.68116 9.73153C5.91916 9.73153 4.49643 8.30908 4.49643 6.54744C4.49643 4.7858 5.91916 3.36335 7.68116 3.36335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8336 15.8916C9.83766 16.8107 8.94024 17.3469 8.29454 17.6532C8.10849 17.7408 7.88961 17.7955 7.68167 17.7955C7.47374 17.7955 7.25486 17.7517 7.06881 17.6532C6.43405 17.3469 5.53663 16.8107 4.52978 15.8916C2.13302 16.1761 0.480469 16.756 0.480469 17.4453C0.480469 18.3973 3.69803 19.1742 7.68167 19.1742C11.6653 19.1742 14.8829 18.3973 14.8829 17.4453C14.8829 16.7669 13.2303 16.1761 10.8445 15.8916H10.8336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirectionSmall);
export default __webpack_public_path__ + "static/media/IconDirectionSmall.81155bd3d668eece6737fa56dc2bc312.svg";
export { ForwardRef as ReactComponent };